module.exports = "/_next/static/images/324f3b45fdd261b41dd266de8bea2335-payed.png.webp";